import * as React from 'react'

function SvgImageAspectRatioRounded(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM8 10H6v2h2v-2zm6 0h2v2h-2v-2zm0 4h2v2h-2v-2zm-4-4h2v2h-2v-2zm-5 8h14c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgImageAspectRatioRounded
